import { useState } from 'react';
import { AxiosError } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { replaceRealEstateReportFile } from '../api';
import { upload } from 'api';

export function useReplaceRealEstateReportFile(onReplace?: () => void) {
  const [loading, setLoading] = useState(false);
  const { addError } = useError();

  const replaceFile = async (reportid: number, file: File) => {
    setLoading(true);

    try {
      const [reportFile] = await upload([file]);
      await replaceRealEstateReportFile(reportid, reportFile);
      onReplace?.();
    } catch (error) {
      addError((error as AxiosError).response?.data.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, replaceFile };
}
